import React from 'react';

const DepositsIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 8.16666V5.66666L6.50008 9L10.6667 12.3333V9.83333H18.1667V8.16666H10.6667ZM16.9517 11.5H15.1817C14.6 12.9326 13.5387 14.1185 12.1792 14.8549C10.8196 15.5914 9.24649 15.8326 7.72879 15.5373C6.21109 15.242 4.84316 14.4285 3.85898 13.236C2.87479 12.0435 2.33553 10.5462 2.33342 9C2.33255 7.45221 2.87027 5.95236 3.85433 4.75768C4.8384 3.56301 6.20749 2.74796 7.72678 2.45234C9.24607 2.15672 10.8209 2.39895 12.1811 3.13748C13.5413 3.87601 14.6022 5.06481 15.1817 6.5H16.9517C15.8901 3.11916 12.7317 0.666664 9.00008 0.666664C4.39758 0.666664 0.666748 4.3975 0.666748 9C0.666748 13.6025 4.39758 17.3333 9.00008 17.3333C12.7317 17.3333 15.8901 14.8808 16.9517 11.5Z"
        fill="currentColor"
        stroke="var(--primaryBackground)"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default DepositsIcon;
